import * as THREE from 'three';
import StarVert from './Star.vert';
import StarFrag from './Star.frag';


function getRandom(min, max) {
    return Math.random() * (max - min) + min;
}


export default class Star {
    constructor(spireTexture, request3DSceneRender, randomizeColor) {
        this.addToScene = this.addToScene.bind(this);
        this.removeFromScene = this.removeFromScene.bind(this);
        this.setPosition = this.setPosition.bind(this);
        this.setRotation = this.setRotation.bind(this);
        this.setScale = this.setScale.bind(this);
        this.twinkle = this.twinkle.bind(this);

        const geometry = new THREE.PlaneGeometry(1, 1);
        const material = new THREE.ShaderMaterial({
            uniforms: {
                'alpha': { type: 'f', value: 2.0 },
                'texture': { type: 't', value: spireTexture },
                // 'colorVariance': { type:'c', value: {r:randomizeColor ? getRandom(0, 1) : 1, g:randomizeColor ? getRandom(0, 1) : 0.8, b:randomizeColor ? getRandom(0, 1) : 0.4} }
                'colorVariance': { type: 'c', value: { r: 253 / 255, g: 247 / 255, b: 216 / 255 } }
            },
            vertexShader: StarVert,
            fragmentShader: StarFrag,
            transparent: true
        });
        this.star = new THREE.Mesh(geometry, material);

        this.scene = null;

        this.twinkleInterval = null;

        this.request3DSceneRender = request3DSceneRender;
        this.clock = new THREE.Clock();

        this.clock.start();
    }

    addToScene = scene => {
        scene.add(this.star);
        this.scene = scene;

        this.twinkle();
    }

    removeFromScene = () => {
        this.scene.remove(this.star);
        this.scene = null;

        if (this.twinkleInterval) {
            clearInterval(this.twinkleInterval);
            this.twinkleInterval = null;
        }
    }

    setPosition = (x, y, z) => {
        this.star.position.set(x, y, z);
    }

    setRotation = (x, y, z) => {
        this.star.rotation.x = x;
        this.star.rotation.y = y;
        this.star.rotation.z = z;
    }

    setScale = (x, y) => {
        this.star.scale.x = x;
        this.star.scale.y = y;
    }

    lookAt(x, y, z) {
        this.star.lookAt(x, y, z);
    }

    twinkle = () => {
        requestAnimationFrame(this.twinkle);
        if (!this.FREQUENCY){
            const FREQUENCY = getRandom(2, 4);
            this.FREQUENCY = FREQUENCY;
            const AMPLITUDE = getRandom(3, 1);
            this.AMPLITUDE = AMPLITUDE;
            const VERTICAL_SHIFT = getRandom(1.5, 3);
            this.VERTICAL_SHIFT = VERTICAL_SHIFT;
        }
        // this.twinkleInterval = setInterval(() => {
            this.star.material.uniforms.alpha.value = this.AMPLITUDE * Math.sin(this.FREQUENCY * this.clock.getElapsedTime()) + this.VERTICAL_SHIFT;
        // }, 1000 / 60);
    }
}